import { initCommerceApiWithGlobals } from 'common-api';
import { logger } from 'common-ui';
import { setRecoil } from 'recoil-nexus';
import { cartAtom } from '../../atoms/cartAtom';

export async function fetchCartWithAtgLegacyApi(): Promise<void> {
  try {
    const commerceApi = initCommerceApiWithGlobals();
    const newCartData = await commerceApi.Cart.get();
    setRecoil(cartAtom, prevState => ({
      ...prevState,
      cartIsLoaded: true,
      cartItems: {
        ...prevState.cartItems,
        ...newCartData,
      },
    }));
  } catch (e) {
    logger.error('API ERROR', e);
  }
}
